<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleInput()">添加</el-button>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input placeholder="分类名称" v-model="query.classifytitle" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable>
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column label="选择" prop="orderid" type="selection" :show-overflow-tooltip="true" width="50"
                align="center" />
            <el-table-column label="缩略图" prop="classifyurl" align="center" width="200">
                <template slot-scope="scope">
                    <el-popover placement="right" trigger="hover">
                        <img :src="scope.row.classifyurl" style="width:400px;border-radius:3px;" />
                        <img slot="reference" :src="scope.row.classifyurl"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;" />
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="父级分类" align="center" prop="parent">
                <template slot-scope="scope">
                    <div v-if="scope.row.parent != null">
                        {{ scope.row.parent.classifytitle }}
                    </div>
                    <div v-if="scope.row.parent == null">/</div>
                </template>
            </el-table-column>
            <el-table-column label="分类名称" align="center" prop="classifytitle" />
            <el-table-column label="序列号" align="center" prop="classifysort" />
            <el-table-column width="200" label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="handleForm(scope.$index, scope.row)">修改
                    </el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.row.classifyid)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <el-pagination class="pagination-container" background :page-size="query.pageSize"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>

        <!--增加-->
        <el-dialog :visible.sync="formInput" :before-close="hideFormInput" width="800px" top="5vh" v-dialogDrag>
            <el-form :model="formData" :rules="formData.parentId==1?formRules:Rules" ref="dataForm" label-width="100px">
                <el-form-item label="分类名称:" prop="classifytitle">
                    <el-input v-model="formData.classifytitle" clearable></el-input>
                </el-form-item>
                <el-form-item label="分类级别:" prop="parentId">
                    <el-select placeholder="请选择" v-model="formData.parentId" @change="rankChange">
                        <el-option label="一级" :value="2"></el-option>
                        <el-option label="二级" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-show="isShow" label="所属父级:" prop="childId">
                    <el-select placeholder="请选择" v-model="formData.childId">
                        <el-option v-for="(item, index) in parentList" :label="item.classifytitle"
                            :value="item.classifyid" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="序列号:" prop="classifysort">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="formData.classifysort" maxlength="8"
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="缩略图:" prop="classifyurl">
                    <div style="display:flex; align-items: flex-end;">
                        <el-upload v-show="pic_is_show" class="avatar-uploader" accept=".png, .jpg, .gif, .jpeg, .bmp"
                            :action="uploadUrl" :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
                            :show-file-list="false" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="formData.classifyurl" :src="formData.classifyurl" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <span style="margin-left:10px">图片大小为680*540(px)</span>
                    </div>
                </el-form-item>
                <el-form-item v-show="isShow" label="商品字段:" prop="idList">
                    <div class="productitem">
                        <el-checkbox v-for="(item, index) in classList" :key="item.id" v-model="item.checked"
                            @change="selectitem(index)">
                            {{item.name}}
                            <el-checkbox class="clecte" v-if="item.checked" v-model="item.issearch" @change="selectitem2(index)">
                                是否筛选项
                            </el-checkbox>
                        </el-checkbox>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideFormInput">取消</el-button>
                <el-button type="primary" @click.native="formSub()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>

        <!--修改-->
        <el-dialog :visible.sync="formVisible" :before-close="hideForm" width="800px" top="5vh" v-dialogDrag>
            <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="100px">
                <el-form-item label="分类名称:" prop="classifytitle">
                    <el-input v-model="formData.classifytitle" clearable></el-input>
                </el-form-item>
                <el-form-item label="分类级别:" prop="parentId">
                    <el-select placeholder="请选择" disabled v-model="formData.parentId" @change="rankChange">
                        <el-option label="一级" :value="2"></el-option>
                        <el-option label="二级" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isShow" label="所属父级:" prop="childId">
                    <el-select @change="changeFn" placeholder="请选择" v-model="formData.childId">
                        <el-option v-for="(item, index) in parentList" :label="item.classifytitle"
                            :value="item.classifyid" :key="item.classifyid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="序列号:" prop="classifysort">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model="formData.classifysort" maxlength="8"
                        clearable></el-input>
                </el-form-item>

                <el-form-item label="缩略图:" prop="classifyurl">
                    <div style="display:flex; align-items: flex-end;">
                        <el-upload v-show="pic_is_show" class="avatar-uploader" accept=".png, .jpg, .gif, .jpeg, .bmp"
                            :action="uploadUrl" :headers="{hfmauth: 'VOB1O/NchSeZ8YFJHVdAzRvZhjZSkJeg'}"
                            :show-file-list="false" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="formData.classifyurl" :src="formData.classifyurl" class="avatar" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <span style="margin-left:10px">图片大小为680*540(px)</span>
                    </div>
                </el-form-item>
                <el-form-item v-if="isShow" label="商品字段:" prop="idList">
                    <div class="productitem">
                        <el-checkbox v-for="(item, index) in classList" :key="item.id" v-model="item.checked"
                            @change="selectitem(index)">
                            {{item.name}}
                            <el-checkbox class="clecte" v-if="item.checked" v-model="item.issearch" @change="selectitem2(index)">
                                是否筛选项
                            </el-checkbox>
                        </el-checkbox>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getList,
        deleteClassify,
        addClassify,
        updateClassify,
        getClassifyRank,
        deleteNewApi,
        getSerchitemList
    } from "../../api/product/classify.js";
    import {
        BASE_URL
    } from "../../config/app";
    const formJson = {
        childId: "",
        classifyid: "",
        classifyurl: "",
        classifytitle: "",
        classifysort: "",
        parentId: "",
        idList: []
    };
    export default {
        data() {
            var checkSort = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error("请输入序列号"));
                } else {
                    var reg = /^[0-9]*$/;
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error("请输入正整数"));
                    }
                }
            };
            var checkZiduan = (rule, value, callback) => {
                if (value.length < 1) {
                    return callback(new Error("商品字段至少选择一项"));
                } else {
                    callback();
                }
            };
            return {
                isShow: "",
                moneyreward: "",
                ordercategory: "",
                dialogImageUrl: "",
                dialogVisible: false,
                cancelToggle: false,
                servicestarttime: [],
                parentList: [],
                query: {
                    tasktheme: "",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formLoading: false,
                formVisible: false,
                formInfo: false,
                formInput: false,
                formData: formJson,
                Rules: {
                    classifytitle: [{
                        required: true,
                        message:"请输入分类名称",
                        trigger: "blur"
                    }],
                    classifysort: [{
                        required: true,
                        validator: checkSort,
                        trigger: "blur"
                    }],
                    classifyurl: [{
                        required: true,
                        message:"请上传封面图",
                        trigger: "blur"
                    }],
                    parentId: [{
                        required: true,
                        message:"请选择分类级别",
                        trigger: "change"
                    }]
                },
                formRules: {
                    classifytitle: [{
                        required: true,
                        message:"请输入分类名称",
                        trigger: "blur"
                    }],
                    classifysort: [{
                        required: true,
                        validator: checkSort,
                        trigger: "blur"
                    }],
                    classifyurl: [{
                        required: true,
                        message:"请上传封面图",
                        trigger: "blur"
                    }],
                    parentId: [{
                        required: true,
                        message:"请选择分类级别",
                        trigger: "change"
                    }],
                    childId: [{
                        required: true,
                        message:"请选择所属父级",
                        trigger: "change"
                    }],
                    idList: [{
                        required: true,
                        validator: checkZiduan,
                        trigger: "change"
                    }]
                },
                uploadUrl: BASE_URL + "/upload/tool/uploadpro",
                pic_is_show: true,
                multipleSelection: [], //多选集合
                classList: []
            };
        },
        methods: {
            /*图片上传之前操作（限制类型大小）*/
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === "image/jpeg" ||
                    file.type === "image/jpg" ||
                    file.type === "image/png";
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error("上图片只能是 JPG/PNG 格式!");
                    return false;
                }
                if (!isLt2M) {
                    this.$message.error("上传图片大小不能超过 2MB!");
                    return false;
                }
                let imgWidth = "";
                let imgHight = "";
                const isSize = new Promise(function (resolve, reject) {
                    let width = 680;
                    let height = 540;
                    let _URL = window.URL || window.webkitURL;
                    let img = new Image();
                    img.onload = function () {
                        imgWidth = img.width;
                        imgHight = img.height;
                        let valid = img.width == width && img.height == height;
                        valid ? resolve() : reject();
                    };
                    img.src = _URL.createObjectURL(file);
                }).then(() => {
                    return file;
                }, () => {
                    this.$message.error("图片尺寸需为650 x 540px。当前上传图片的尺寸为：" + imgWidth + "x" + imgHight + "px");
                    return Promise.reject();
                    return false;
                });
                return isJPG && isLt2M && isSize;
            },
            // 获取所属父级
            getClassifyRankList() {
                getClassifyRank().then(res => {
                    console.log(res);
                    this.parentList = res.data;
                });
            },
            //选择商品字段
            selectitem(index) {
                let data = this.classList[index]
                if (this.formData.idList.length > 0) {
                    //查找目标项
                    let data2 = this.formData.idList.filter((item) => {
                        return item.id == data.id;
                    });
                    if (data2.length < 1) {
                        //数组中没有该项
                        this.formData.idList.push(data)
                    } else {
                        //数组中已存在该项，删除
                        this.formData.idList.forEach((item, index) => {
                            if (data2[0].id == item.id) {
                                this.formData.idList.splice(index, 1);
                            }
                        })
                    }
                } else {
                    this.formData.idList.push(data)
                }
            },
            //是否搜索项
            selectitem2(index){
              let data = this.classList[index]
              //查找目标项
              let data2 = this.formData.idList.filter((item) => {
                return item.id == data.id;
              });
              //console.log('data2',data2)
              data2[0].issearch=data.issearch
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.getList();
                this.getClassifyRankList();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            //切换分来
            rankChange(val) {
                if (val == 2) {
                    this.isShow = false;
                    this.$nextTick(() => {
                        this.$refs["dataForm"].clearValidate();
                    });
                } else {
                    this.isShow = true;
                    this.$nextTick(() => {
                        this.$refs["dataForm"].clearValidate();
                    });
                }
                this.formData.parentId = val;
                console.log(this.formData.parentId);
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.classifyid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
                // var ids = this.multipleSelection
                //     .map(item => item.classifyid)
                //     .join(); //获取所有选中行的id组成的字符串，以逗号分隔
                // if (ids == "") {
                //     this.$message({
                //         message: "请先选择",
                //         type: "warning"
                //     });
                //     return;
                // }
                // this.handleDel(ids);
            },
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.msgtime = [];
                this.getList();
                this.getClassifyRankList();
            },
            onSubmit() {
                this.$router.push({
                    path: "",
                    query: this.query
                });
                this.getList();
                this.getClassifyRankList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
                this.getClassifyRankList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
                this.getClassifyRankList();
            },

            handleAvatarSuccess(res, file) {
                this.formData.classifyurl = res.data;
            },
            regetlist() {
                this.query.currentPage = this.query.currentPage - 1
                this.getList();
            },
            getList() {
                this.loading = true;
                getList(this.query)
                    .then(response => {
                        console.log(response);
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        if (this.query.currentPage > 1 && response.data.list.length < 1) {
                            this.regetlist();
                        } else {
                            this.list = response.data.list || [];
                            this.totalNumber = response.data.totalNumber || 0;
                            setTimeout(() => {
                                this.loading = false;
                            }, 0.3 * 1000);
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                this.$refs["dataForm"].resetFields();
                this.isShow = false;
                this.classList.forEach(item => {
                    item.checked = false
                    item.issearch = false
                })
                return true;
            },
            hideFormInput() {
                // 更改值
                this.formInput = !this.formInput;
                this.$refs["dataForm"].resetFields();
                this.isShow = false;
                this.classList.forEach(item => {
                    item.checked = false
                    item.issearch = false
                })
                return true;
            },

            hideInfo() {
                // 更改值
                this.formInfo = !this.formInfo;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.$refs.tinymce.clearContent();
                this.query.classifytitle = "";
                return true;
            },
            hideInput() {
                // 更改值
                this.formInput = !this.formInput;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.query.classifytitle = "";
                return true;
            },
            changeFn(e) {
                console.log(e);
                console.log(this.formData.childId);
                // this.formData.childId = e;
                this.$forceUpdate()
                console.log(this.formData.childId);
            },
            // 显示表单
            handleForm(index, row) {
                console.log(row);
                //清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }

                if (row.hfSerchitemList.length > 0) {
                    //循环添加到规格数组中
                    this.classList.forEach(item => {
                        row.hfSerchitemList.forEach(itm => {
                            if (item.id == itm.id) {
                                item.checked = true
                                if (itm.enableSearch == 1) {
                                    item.issearch = true
                                }
                            }
                        })
                    })
                    //已选中规格
                    row.idList = []
                    row.hfSerchitemList.forEach(itm => {
                        row.idList.push({
                            id: itm.id,
                            name: itm.nameZh,
                            issearch: itm.enableSearch == 1 ? true : false,
                            checked: true
                        })
                    })
                } else {
                    row.idList = []
                }

                this.formData = formJson;
                if (row !== null) {
                    this.formData = Object.assign(this.formData, row);
                }
                this.formVisible = true;
                if (row && !!row.parentId == 0) {
                    this.formData.parentId = 2;
                }
                if (row && !!row.parentId) {
                    this.formData.parentId = 1;
                    this.formData.childId = row.parent.classifyid;
                    this.isShow = true;
                } else {
                    this.isShow = false;
                }
            },
            //新增
            handleInput() {
                this.isShow = false;
                this.$nextTick(() => {
                    this.$refs["dataForm"].resetFields();
                });
                console.log(this.isShow);
                this.formInput = true;
                this.formData = Object.assign({}, formJson);
                this.formData = {
                    childId: "",
                    classifyid: "",
                    classifyurl: "",
                    classifytitle: "",
                    classifysort: "",
                    parentId: "",
                    idList: []
                }
            },

            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formData.msgtime = "";
                        let data = Object.assign({}, this.formData);
                        data.parentId == 1 ?
                            (data.parentId = data.childId) :
                            (data.parentId = 0);
                        if (data.parentId == 2) {
                            data.parentId = 0
                        }
                        //规格数据strart
                        var list = []
                        data.idList.forEach(item => {
                            if (item.issearch == true) {
                                item.issearch = 1
                            } else {
                                item.issearch = 2
                            }
                            list.push({
                                searchitemId: item.id,
                                issearch: item.issearch,
                            })
                        })
                        data.idList = list
                        //规格数据end
                        updateClassify(data).then(response => {
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            //this.$refs.tinymce.clearContent();
                            this.formVisible = false;
                            this.query.classifytitle = "";
                            this.getList();
                            this.getClassifyRankList();
                            this.isShow = false;
                            this.classList.forEach(item => {
                                item.checked = false
                                item.issearch = false
                            })
                        });
                    }
                });
            },
            formSub() {
              console.log('formSub')
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        let data = Object.assign({}, this.formData);
                        data.parentId == 1 ?
                            (data.parentId = data.childId) :
                            (data.parentId = 0);
                        if (data.parentId == 2) {
                            data.parentId = 0
                        }
                        //规格数据strart
                        var list = []
                        data.idList.forEach(item => {
                            if (item.issearch == true) {
                                item.issearch = 1
                            } else {
                                item.issearch = 2
                            }
                            list.push({
                                searchitemId: item.id,
                                issearch: item.issearch,
                            })
                        })
                        data.idList = list
                        //规格数据end
                        addClassify(data).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            //this.$refs["dataForm"].resetFields();
                            //this.$refs.tinymce.clearContent();
                            this.formInput = false;
                            this.query.classifytitle = "";
                            this.getList();
                            this.getClassifyRankList();
                            this.$refs["dataForm"].resetFields();
                            this.isShow = false;
                            this.classList.forEach(item => {
                                item.checked = false
                                item.issearch = false
                            })
                        });
                    }
                });
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            deleteNewApi({
                                    ids: ids.toString()
                                })
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    this.getList();
                                    this.getClassifyRankList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            },
            //获取数据规格字段列表
            getSerchitemList() {
                getSerchitemList().then(res => {
                    res.data.forEach(item => {
                        this.classList.push({
                            id: item.id,
                            name: item.nameZh,
                            checked: false,
                            issearch: false
                        })
                    })
                });
            }
        },
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
            this.getSerchitemList();
            this.getClassifyRankList();
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
    margin: 0;
}
.app_logo {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.loading_div {
    width: 150px;
    height: 150px;
    border-radius: 5px;
    max-width: 150px;
    max-height: 150px;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.productitem{
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-y: auto;
  width: 400px;
  border: 1px solid #DCDFE6;
  margin-bottom: 10px;
  padding-left: 15px;
}
.clecte{
  margin-left: 30px;
}
</style>
